import { InterviewStatus } from "@src/appV2/redesign/WorkerShifts/api/useFetchPaginatedInterviews";

export const RECENT_PLACEMENT_DAYS_THRESHOLD = 7;

export const HIRING_TEXTING_PHONE_NUMBER = "+19085625161";

/**
 * Priority order for sorting and displaying interview statuses.
 * Lower index = higher priority (shown first).
 */
export const INTERVIEW_STATUS_PRIORITY = [
  InterviewStatus.BOOKED,
  InterviewStatus.ATTENDANCE_CONFIRMED,
  InterviewStatus.CANCELLED,
  InterviewStatus.NO_CALL_NO_SHOW,
  InterviewStatus.RESCHEDULED,
] as const;
